var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"pt-3",attrs:{"id":"settings"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('MyBoat')],1),_c('v-col',{attrs:{"cols":"12"}},[_c('SystemStatus')],1),_c('v-col',{attrs:{"cols":"12"}},[_c('Control')],1),_c('v-col',{attrs:{"cols":"12"}},[_c('Sensors')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }